import 'ui-core/widgets/publication-content/js/publication-content';

UX.loader.uniqueTabsId = () => {
    let articleMenuTabs = $('#articleMenu li.tab__nav__item a');
    articleMenuTabs.map((key, el) => {
        let id = el.id;
        let random = Math.floor(Math.random() * 10000);
        $(el).attr('id', id + '-' + random);
    });
};

UX.loader.init = () => {
    UX.loader.$tabs = $('article .tab');
    UX.loader.$spinner = $('.tab__spinner');
    UX.loader.defaultTab = UX.loader.$tabs.data('default-tab');
    UX.loader.get.figures();
    UX.loader.get.references();
    UX.loader.get.related();
    UX.loader.get.details();
    UX.loader.controller();
    if ($('article')) {
        UX.loader.load.articleTabs();
    }
    UX.loader.additionalController();
    UX.loader.truncation.init();
    UX.loader.tableToggle();
    UX.loader.uniqueTabsId();
};
UX.loader.additionalController = () => {
    const articleRightrailSticko = document.querySelector('article .sticko__parent > .tab');
    let heightOffset = 0;
    if (articleRightrailSticko) {
        let currentElement = articleRightrailSticko.previousElementSibling;
        while (currentElement !== null) {
            heightOffset += currentElement.offsetHeight;
            currentElement = currentElement.previousElementSibling;
        }
    }
    articleRightrailSticko.style.height = `calc(100% - ${heightOffset}px)`;
    $('.ref__fulltext .references__item').removeAttr('id');
};
